import { createWysimark } from '@wysimark/standalone'
(window as any).createWysimark = createWysimark